import { render, staticRenderFns } from "./ChooseLoyaltyReward.vue?vue&type=template&id=6717ee7a&scoped=true&"
import script from "./ChooseLoyaltyReward.vue?vue&type=script&lang=ts&"
export * from "./ChooseLoyaltyReward.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseLoyaltyReward.vue?vue&type=style&index=0&id=6717ee7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717ee7a",
  null
  
)

export default component.exports